export interface CryptoPrice {
  id: string;
  name: string;
  symbol: string;
  current_price: number;
  market_cap_change_percentage_24h: number;
  price_change_percentage_24h: number;
}

const COINGECKO_API = "https://api.coingecko.com/api/v3";

export async function getCryptoPrices(): Promise<CryptoPrice[]> {
  try {
    const response = await fetch(
      `${COINGECKO_API}/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=10&sparkline=false&locale=en`
    );
    return response.json();
  } catch (error) {
    console.error("Error fetching crypto prices:", error);
    return [];
  }
}

export async function getCryptoPrice(id: string): Promise<CryptoPrice | null> {
  try {
    const response = await fetch(
      `${COINGECKO_API}/coins/${id}?localization=false&market_data=true`
    );
    const data = await response.json();
    return {
      id: data.id,
      name: data.name,
      symbol: data.symbol.toUpperCase(),
      current_price: data.market_data.current_price.usd,
      market_cap_change_percentage_24h:
        data.market_data.market_cap_change_percentage_24h,
      price_change_percentage_24h: data.market_data.price_change_percentage_24h,
    };
  } catch (error) {
    console.error("Error fetching crypto price:", error);
    return null;
  }
}
